import Vue from 'vue';

import {
  Header,
} from '@/components';

export default {
  name: 'App',
  components: {
    [Header.name]: Header,
  },
  props: {},
  data: () => ({}),
  computed: {},
  methods: {},
  watch: {
    $route() {
      document.title = Vue.prototype.$gettext('General - Page title') || 'Q Team';
    },
  },
  created() {
    // Firefox fix: prevent backspace from going to previous page
    window.addEventListener('keydown', (e) => {
      if (e.keyIdentifier === 'U+0008' || e.keyIdentifier === 'Backspace' || e.keyCode === 8) {
        if (e.target === document.body) {
          e.preventDefault();
          return false;
        }
      }

      return true;
    }, true);
  },
};
